import { dateStringsOnSameDay, to_YYYYMMDDHHMMSS } from "../config/dateFormatting";
import { ISeatingContent, IVersionedObject } from "../planEatApi/PlanEatFacade";

export function getSeatingsOnDate(date: Date, seatings: IVersionedObject<ISeatingContent>[]){
    var dateString = to_YYYYMMDDHHMMSS(date)
    let seatingsOndate: IVersionedObject<ISeatingContent>[] = []
    if (seatings.length !== 0 && date) {
        seatings.forEach(function (seating) {
            if(dateStringsOnSameDay(dateString,seating.content.seatingStart)){
                seatingsOndate.push(seating)
            }
        });
    }
    return seatingsOndate
}